import { defineStore } from 'pinia'
import newsQuery from '../apollo/queries/pages/vision/news.gql'

export const useNewsStore = defineStore('news', {
  state: () => ({
    data: {}
  }),
  getters: {
    getNews: (state) => {
      return state.data.news ? state.data.news.data : null
    }
  },
  actions: {
    async requestData() {
      if (Object.keys(this.data).length !== 0) return

      const { data } = await useAsyncQuery(newsQuery) // eslint-disable-line no-undef

      if (data) this.data = data
    }
  }
})
